import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Avatar, Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { Pagination } from "@mui/material";
import { BreadcrumbAdmin } from "../../../UI/BreadcrumbAdmin";
import "./TaskDetailed.css";
import DefaultMaleProfilePic from "../../../../assets/Icons/profile/Profile icon _ male.png";
import { TaskAccordian } from "./TaskAccordian";
import {
  getBookTaskCountForStatus,
  TaskVerificationBookCard,
} from "./TaskVerificationBookCard";
import { useGetPendingTaskByIdQuery } from "../../../../redux-toolkit/features/books/bookApiSlice";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import ProgressBar from "../../../UI/ProgressBar";
import { Error404 } from "../../../UI/404/Error404";
import { NoRecord } from "../../../UI/No record/NoRecord";

const sectionTabSx = {
  textTransform: "capitalize",
  fontWeight: "500",
  fontSize: "15px",
};

const data = [
  { _id: "B1" },
  { _id: "B2" },
  { _id: "B3" },
  { _id: "B4" },
  { _id: "B5" },
  { _id: "B6" },
  { _id: "B7" },
];

export const TaskDetailed = () => {
  const { _id } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const taskType = searchParams.get("type") || "ORG";
  const isOrgType = taskType !== "COMPANY";
  const verificationListPath = location.pathname.includes(
    "/super-admin/manage-organization/task-verification"
  )
    ? "/super-admin/manage-organization/task-verification"
    : "/admin/manage-company/task-verification";
  const [openSection, setOpenSection] = React.useState("PENDING");
  const [selectedBookId, setSelectedBookId] = React.useState(null);
  const PAGE_SIZE = 5;
  const [sectionPages, setSectionPages] = React.useState({
    PENDING: 1,
    APPROVED: 1,
    REJECTED: 1,
  });

  const summaryQuery = useGetPendingTaskByIdQuery(
    {
      _id,
      type: taskType,
      status: "PENDING",
      limit: 1,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const bookTasksQuery = useGetPendingTaskByIdQuery(
    {
      _id,
      type: taskType,
      status: openSection,
      bookId: selectedBookId,
      page: sectionPages[openSection],
      limit: PAGE_SIZE,
    },
    {
      skip: !selectedBookId,
      refetchOnMountOrArgChange: true,
    }
  );

  const summaryData =
    summaryQuery.data?.data || bookTasksQuery.data?.data || {};

  const activeTasks = bookTasksQuery.data?.data?.tasks || [];
  const activePagination = bookTasksQuery.data?.data?.tasksPagination || {
    totalPages: 1,
    totalResults: 0,
  };
  const activePage = sectionPages[openSection] || 1;
  const activePageCount = Math.max(1, activePagination?.totalPages || 1);

  const allCounts = {
    pending: summaryData?.pendingTasks || 0,
    approved: summaryData?.approvedTasks || 0,
    rejected: summaryData?.rejectedTasks || 0,
    submitted: summaryData?.submittedTasks || 0,
  };

  const sectionConfig = [
    {
      key: "PENDING",
      label: "Pending Tasks",
      count: allCounts.pending,
    },
    {
      key: "APPROVED",
      label: "Approved Tasks",
      count: allCounts.approved,
    },
    {
      key: "REJECTED",
      label: "Rejected Tasks",
      count: allCounts.rejected,
    },
  ];

  const activeTabIndex = Math.max(
    0,
    sectionConfig.findIndex((section) => section.key === openSection)
  );

  const selectedBook = (summaryData?.bookSummaries || []).find(
    (book) => String(book._id) === String(selectedBookId)
  );

  const booksForActiveStatus = (summaryData?.bookSummaries || []).filter(
    (book) => getBookTaskCountForStatus(book, openSection) > 0
  );

  const handleSectionTabChange = (_event, newValue) => {
    setSelectedBookId(null);
    setOpenSection(sectionConfig[newValue]?.key || "PENDING");
  };

  const handleBookSelect = (bookId) => {
    setSelectedBookId(bookId);
    setSectionPages((prev) => ({
      ...prev,
      [openSection]: 1,
    }));
  };

  const base = [
    {
      _id: 1,
      link: verificationListPath,
      label: "Task Verification",
    },
  ];

  const isLoading = selectedBookId
    ? bookTasksQuery.isLoading
    : summaryQuery.isLoading;

  const isFetching = selectedBookId
    ? bookTasksQuery.isFetching
    : summaryQuery.isFetching;

  const isError = selectedBookId
    ? bookTasksQuery.isError
    : summaryQuery.isError;

  if (isLoading || isFetching) {
    return <ProgressBar />;
  }

  if (isError) {
    return <Error404 />;
  }

  const showBookGrid = !selectedBookId;
  const showTaskList = !!selectedBookId;
  const breadcrumbPage =
    selectedBookId && selectedBook ? selectedBook.name : "All Tasks";

  return (
    <>
      {summaryData?.user ? (
        <div className="container">
          <BreadcrumbAdmin base={base} page={breadcrumbPage} />

          <div className="taskdetHead">
            <div className="task__head">
              <div className="task__headprofile">
                <Avatar
                  alt="Remy Sharp"
                  sx={{ width: "65px", height: "65px" }}
                  src={
                    summaryData?.user?.avatar
                      ? summaryData.user.avatar
                      : DefaultMaleProfilePic
                  }
                />

                <div className="task__headnotf">{allCounts.pending}</div>
              </div>
              <div>
                <div>
                  <h2>
                    {summaryData?.user?.fname} {summaryData?.user?.lname}
                  </h2>
                </div>
                <div>
                  <h4 className="ftwt__r"> {summaryData?.user?.company}</h4>
                </div>
              </div>
            </div>
            <div className="taskdetHead__right">
              <div className="taskDet__books">
                <div className="taskDet__bookshead">
                  <h5 className="ftwt__r">Attempted</h5>
                  <h6 className="ftwt__r">
                    {summaryData?.submittedTasks ?? allCounts.submitted}/
                    {summaryData?.totalTasks || 0}
                    &nbsp; Tasks
                  </h6>
                </div>
                {isOrgType ? (
                  <div className="taskDet__bookscontent">
                    {data.map((elm, index) => (
                      <div
                        key={index}
                        className={
                          index < (summaryData?.lastBook || 0)
                            ? "taskDet__bookscard"
                            : "taskDet__bookscardIA"
                        }
                      >
                        <caption>Book {index + 1}</caption>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          <div className="taskdetHead__cards">
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={activeTabIndex}
                  onChange={handleSectionTabChange}
                  aria-label="task status tabs"
                >
                  {sectionConfig.map((section) => (
                    <Tab
                      key={section.key}
                      label={`${section.label} (${section.count})`}
                      sx={sectionTabSx}
                    />
                  ))}
                </Tabs>
              </Box>
            </Box>

            {showBookGrid ? (
              booksForActiveStatus.length ? (
                <div className="taskVerificationBookGrid">
                  {booksForActiveStatus.map((book) => (
                    <TaskVerificationBookCard
                      key={book._id}
                      book={book}
                      status={openSection}
                      onSelect={handleBookSelect}
                    />
                  ))}
                </div>
              ) : (
                <div className="taskdetSection__empty">
                  <p>No {openSection.toLowerCase()} tasks found.</p>
                </div>
              )
            ) : null}

            {showTaskList ? (
              <>
                <div className="taskdetSection__bookHeader">
                  <div className="taskdetSection__back">
                    <button
                      type="button"
                      className="taskdetSection__backBtn"
                      onClick={() => setSelectedBookId(null)}
                    >
                      <ArrowBackIosNewIcon sx={{ fontSize: 14 }} />
                      Back to books
                    </button>
                  </div>
                  {selectedBook?.name ? (
                    <h3 className="taskdetSection__bookTitle">{selectedBook.name}</h3>
                  ) : null}
                </div>

                {activeTasks.length ? (
                  <div className="taskdetSection__content">
                    {activeTasks.map((taskItem) => (
                      <TaskAccordian
                        key={taskItem?._id}
                        taskData={taskItem}
                        hideBookName
                      />
                    ))}
                  </div>
                ) : (
                  <div className="taskdetSection__empty">
                    <p>No {openSection.toLowerCase()} tasks found.</p>
                  </div>
                )}

                {(activePagination?.totalResults || 0) > PAGE_SIZE ? (
                  <div className="taskdetSection__pagination">
                    <Pagination
                      count={activePageCount}
                      shape="rounded"
                      page={activePage}
                      onChange={(_, newPage) =>
                        setSectionPages((prev) => ({
                          ...prev,
                          [openSection]: newPage,
                        }))
                      }
                    />
                  </div>
                ) : null}
              </>
            ) : null}
          </div>
        </div>
      ) : (
        <div className="container">
          <BreadcrumbAdmin base={base} />

          <NoRecord />
        </div>
      )}
    </>
  );
};
